import React from 'react'
import { t } from '@lingui/macro'
import GeneralRemoveModal from '../../../components/common/general-remove-modal/GeneralRemoveModal'
import { useRemoveUserMutation } from './ArchiveUserModal.codegen'

interface IProps {
  userId: number
  show: boolean
  onCanceled: () => void
  onDeleted: () => void
  actionName: string
}

export const ArchiveUserModal = (props: IProps) => {
  const [archiveUserMutation] = useRemoveUserMutation()
  return (
    <GeneralRemoveModal
      entityName={t`user`}
      confirmButton={t`Archive user`}
      header={t`Archive user`}
      operation={async () =>
        archiveUserMutation({
          variables: {
            userId: props.userId
          }
        })
      }
      {...props}
    />
  )
}
